// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ai3iz3ksdQJNLc {
  cursor: pointer;
}
.Gn87mV4xr5HQJh {
  font-weight: var(--ds-font-weight-bold, bold);
}
`, ""]);
// Exports
export var inlineMember = `Ai3iz3ksdQJNLc`;
export var fontWeightBold = `Gn87mV4xr5HQJh`;
export default ___CSS_LOADER_EXPORT___;
